import { render } from "./ChannelInfo.vue?vue&type=template&id=023f8817&scoped=true&bindings={\"channelId\":\"props\",\"config\":\"setup\",\"stream\":\"setup\",\"channel\":\"setup\",\"favorite\":\"setup\",\"owned\":\"setup\",\"ownedBefore\":\"setup\",\"followersDiff\":\"setup\",\"prettyFollowers\":\"setup\",\"prettyFollowersDiff\":\"setup\",\"startedFromNow\":\"setup\",\"streamedFromNow\":\"setup\",\"toggleAvatar\":\"setup\",\"toggleFavorite\":\"setup\"}"
import script from "./ChannelInfo.vue?vue&type=script&lang=js"
export * from "./ChannelInfo.vue?vue&type=script&lang=js"

import "./ChannelInfo.vue?vue&type=style&index=0&id=023f8817&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-023f8817"

export default script